import React from 'react'

import SiteMeta from '../meta/meta';
import Navbar from './Navbar'
import './all.sass'

const TemplateWrapper = ({ children }) => (
  <div>
    <SiteMeta title="29歳未経験からエンジニア始めました" />
    <Navbar />
    <div>{children}</div>
  </div>
)

export default TemplateWrapper
